import { connect } from "react-redux";
import RmLog from "./complaintLog";
import { bindActionCreators } from "redux";
import {
  getComplaintLog
} from "services/redux/installation/siteLog/action";

const mapStateToProps = (state) => ({
  complaintLog: state.siteLogReducer.complaintLog,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getComplaintLog
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RmLog);
